import { AnimationBaseController, IAnimationControllerConfiguration, Inject, IBaseController } from "@denishussar/html5-game-engine";
import { CameraConstants } from "../../Constants/CameraConstants";
import { CameraHelpers } from "../../Helpers/Helpers";
import { GameLogic } from "../../Logic/GameLogic";
import { GameModel } from "../../Models/GameModel";
import { AnimationContents } from "../AnimationContents";

export interface IGrassControllerOptions {

}
export class GrassController extends AnimationBaseController {
    $model: GameModel;


    public constructor(
        @Inject private _options: IGrassControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super("GrassController");
        console.log('GrassController', this);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.GRASS_SCREEN_JSON,
            libraryName: 'grass',
            childControllers: {

            },
            modelWatch: {
                cameraIndex: (cameraIndex: CameraConstants) => {
                    let scale = 1;
                    if (CameraHelpers.isCameraZoomed(cameraIndex)) {
                        scale = 1.5;
                        this.gotoAndStopByQuery('right', 1);
                        this.gotoAndStopByQuery('left', 1);
                    } else {
                        this.gotoAndStopByQuery('right', 0);
                        this.gotoAndStopByQuery('left', 0);
                    }
                    this.scaleX = scale;
                    this.scaleY = scale;
                }
            }
        };
    }

    protected onInitialize(): void {
        // this.scaleX = 1.4;
        // this.scaleY = 1.4;
    }


}